import { AxiosResponse } from 'axios'
import { MagentoEntityUrl } from 'lib/types'
import { ServiceDependencies } from 'lib/core/services/magento'
import { axiosClient } from 'lib/core/services/magento/client'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface UrlResolverQueryObject {
  urlResolver: {
    __args: {
      url: string
    }
    id: boolean
    type: boolean
    sku: boolean
    relative_url: boolean
  }
}

export const urlResolverQueryObject: UrlResolverQueryObject = {
  urlResolver: {
    __args: {
      url: ''
    },
    id: true,
    type: true,
    sku: true,
    relative_url: true
  }
}

interface UrlResolverQueryInput {
  path: string
}

export type UrlResolverQuery = (input: UrlResolverQueryInput) => Promise<AxiosResponse<{ data: { urlResolver: MagentoEntityUrl } }>>

export const createUrlResolverQuery = ({ getQueries }: ServiceDependencies): UrlResolverQuery => async ({ path }) => {
  const query = getQueries().urlResolverQuery
  query.urlResolver.__args.url = path

  return axiosClient(jsonToGraphQLQuery(query), true)
}
